export const AppPages = {
  Dashboard: "Dashboard",
  Trading: "Trading",
  MomentumTrading: "MomentumTrading",
  SaleEngine: "SaleEngine",
  LivePrediction: "LivePrediction",
  BackTesting: "BackTesting",
  ConfigureTrend: "ConfigureTrend",
  ManagePaperTrade: "ManagePaperTrade",
  Screening: "Screening",
};
